import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";

import App from "./App";
import AuthProvider from "./auth/AuthProvider";
import UserProvider from "./auth/UserProvider";
import configureStore from "./store/configureStore";

import "./utils/consolewarning";
import "./assets/polyfills";

const reduxStore = configureStore();

window.__REPORTS_REDUX_STORE__ = reduxStore;

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={reduxStore}>
    <AuthProvider>
      <UserProvider>
        <App />
      </UserProvider>
    </AuthProvider>
  </Provider>,
);
